
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import DashboardPage from './pages/Dashboard';
import LoginPage from './pages/Login';
import OrdersPage from './pages/Orders';
import BankAccountForm from './pages/BankAccountForm';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' Component={DashboardPage} />
        <Route path='/dashboard' Component={DashboardPage} />
        <Route path='/login' Component={LoginPage} />
        <Route path='/orders' Component={OrdersPage} />
        <Route path='/setpayment' Component={BankAccountForm} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
